<template>
  <div>
    <Carousel
      v-if="showCarousel"
      :perPageCustom="[[400, 2], [768, 4], [1024, 5]]"
      :paginationEnabled="false"
      :navigationEnabled="true"
      :loop="true"
      :navigationPrevLabel="`<span class='prevButton'></span>`"
      :navigationNextLabel="`<span class='nextButton'></span>`">
      <Slide v-for="(picture, index) in pictures" :key="index">
        <div @click="showImageModal(picture.url)" class="h-40 w-full absolute cursor-pointer"></div>
        <img
          :class=" !isMyProfile  && (userData.profile.make_visible === 0 || userData.pictures.length === 0) && (userData.subscription_status ? userData.subscription_status !== 'active' : true) ? 'blurImage': ''"
          :src="picture.url"
          class="object-cover object-center h-40 rounded-lg cursor-pointer"
          alt="picture" />
      </Slide>
    </Carousel>
    <transition name="image-modal">
      <div class="modal-mask" v-if="showImage" @click="showImage = false">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="text-right bg-transparent">
              <span @click="showImage = false" class="jw-photo-close">X</span>
            </div>
            <div class="h-full w-full absolute"></div>
            <img
              :src="imagePath"
              class="object-cover object-center"
              alt="picture" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { mapState, mapActions } from "vuex";
export default {
  name: "PhotoCarouselWrapper",
  props: ['pictures','userData', 'isMyProfile'],
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      showCarousel: false,
      showImage: false,
      imagePath: null
    }
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  mounted() {
    setTimeout(() => {
      this.showCarousel = true;
    }, 100);
  },
  methods: {
    showImageModal(imgUrl) {
      if (imgUrl !== '/storage/image/placeholder-user.jpg') {
        this.showImage = true;
        this.imagePath = imgUrl;
      }
    }
  }
};
</script>

<style lang="scss">
.jw-photo-close {
  border-radius: 50%;
  background: #000000;
  color: white;
  padding: 5px 10px;
  font-size: 0.8rem;
  font-weight: 900;
  cursor: pointer;
  margin-bottom: 5px;
  display: inline-block;
  margin-left: -22px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  border-radius: 2px;
  transition: all .3s ease;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.VueCarousel {
  width: auto;
}

.VueCarousel-inner {
  justify-content: initial !important;
}
.VueCarousel-slide {
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  padding: 5px;
}

.VueCarousel-navigation-button {
  position: absolute;
  top: 50%;
  box-sizing: border-box;
  color: #000;
  text-decoration: none;
  appearance: none;
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  outline: none;

  &.VueCarousel-navigation-prev, &.VueCarousel-navigation-next {
    position: absolute;
    top: 50%;
    width: 32px;
    height: 32px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.VueCarousel-navigation-prev {
    margin: 0 15px;
    transform: translateY(-50%) translateX(-100%);
    font-family: "system";
    background-image: url("/storage/image/arrow_left.png");
    right: auto;
    left: -5px;
  }

  &.VueCarousel-navigation-next {
    background-image: url("/storage/image/arrow_right.png");
    left: auto;
    right: 10px;
    top: 59%;
  }
}
</style>
